<div class="banner-container">
  <div class="banner">
    <img src="../../../assets/images/Banner_Telekom.jpg" alt="Banner Bild" />
  </div>
</div>
